import downloadPDF from "@/mixins/downloadPDF";
import Utils from "@/mixins/Utils";
import difService from "@/services/dif";

export default {
  components: {
    // SectionTitle,
  },
  mixins: [downloadPDF, Utils],
  data: () => ({
    nbDIF: null,
    filePath: null,
    spinnerDIF: true,
    errorMyDIF: false,
  }),
  created() {
    this.getDIFHours();
  },
  methods: {
    getDIFHours() {
      const vue = this;
      difService
        .getDIFHours()
        .then(function(response) {
          if (response.success) {
            vue.nbDIF = response.data.dif;
          } else {
            vue.errorMyDIF = true;
          }
        })
        .catch(function(error) {
          vue.errorMyDIF = true;
        })
        .finally(function() {
          vue.spinnerDIF = false;
        });
    },
    genererAttestationDIF() {
      const vue = this;
      difService
        .generateAttestationDIF()
        .then(function(response) {
          if (response.success) {
            vue.filePath = response.data.filePath;
            vue.checkFileExistanceAndDownload(vue.filePath);
          }
        })
        .catch(function(error) {
          vue.callToaster(
            `${vue.$t("error-generate-DIF")}: ${response.data.message}`
          );
        });
    },
  },
};
